import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { ApplicationPrefix } from '@openx/constants/paths.ts';
import type { FloorRuleApi } from '@openx/types/floorrule.ts';
import { getBasenameWithInstanceId } from '@openx/utils/lib/getBasenameWithInstanceId.ts';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import type { PackageRouteParams } from '../../../../types.ts';
import { usePackageContext } from '../../../../utils/context/PackageContext.tsx';
import { UsedByEntry } from './UsedByEntry.tsx';

const FIELDS = 'name,status,start_date,end_date';
const LIMIT = 10;

export const UsedByBrandFloors = () => {
  const { t } = useTranslation();
  const { packageId } = useParams<PackageRouteParams>();

  const { useFloorsFetch } = usePackageContext();

  const [floorsList, setFloorList] = useState<FloorRuleApi[]>([]);

  const [floorsPage, setFloorsPage] = useState(0);

  const { floorsLoading, floorRules, floorsFetching } = useFloorsFetch(packageId as string, {
    fields: FIELDS,
    limit: LIMIT,
    offset: LIMIT * floorsPage,
    sort: 'name',
  });

  useEffect(() => {
    setFloorList(prevState => [...prevState, ...(floorRules.objects as FloorRuleApi[])]);
  }, [floorRules.objects]);

  const showMoreFloors = useCallback(() => setFloorsPage(prev => prev + 1), []);

  const getPathToFloorDetails = useCallback(
    (id: string) => `${getBasenameWithInstanceId(ApplicationPrefix.Publisher)}/pricing/floors/${id}/details`,
    []
  );

  if (floorsLoading) {
    return <Loader />;
  }

  return (
    <UsedByEntry
      title={t('Brand Floors')}
      showMore={showMoreFloors}
      idRowTitle={t('Floor ID:')}
      entries={floorsList}
      hasMore={floorRules.has_more}
      getPathToDetails={getPathToFloorDetails}
      isOutsideLink
      isFetchingMore={floorsFetching}
      dataTest="brand-floors-area"
      entriesNumber={floorsList.length}
    />
  );
};
